<div #scrollContainer class="d-flex flex-column new-input-fields">
  <div>
    <label>Title
      <input type="text" placeholder="Enter title here..." [(ngModel)]="event.name"/>
    </label>
  </div>
  <div class="mb-3">
    <label>Description
      <div class="padding-10" style="border:1px solid #cacaca;border-radius: 3px;" [froalaEditor]="editorOptions" [(froalaModel)]="event.description"></div>
    </label>
  </div>
  <div>
    <label>Location
      <input type="text" placeholder="Location" [(ngModel)]="event.location"/>
    </label>
  </div>
  <!--  <div>-->
  <!--    <label>Link-->
  <!--      <input type="text" placeholder="Link" [(ngModel)]="event.link"/>-->
  <!--    </label>-->
  <!--  </div>-->
  <div class="d-flex flex-column mt-2 mb-2 padding-10" style="background: rgba(234, 236, 240, 0.5);border-radius: 4px;">
    <div class="d-flex" *ngFor="let linkItem of eventLinks; let index = index;">
      <div class="d-flex flex-column w-100 margin-right">
        <div>
          <label>Link Name</label>
        </div>
        <div>
          <input type="text" [(ngModel)]="linkItem.name" placeholder="Link Name"/>
        </div>
      </div>
      <div class="d-flex flex-column w-100 margin-right">
        <div>
          <label>Link Name</label>
        </div>
        <div>
          <input type="text" [(ngModel)]="linkItem.link" placeholder="Link"/>
        </div>
      </div>
      <div class="d-flex">
        <i style="position: relative;top: 25px;" class="material-icons delete-icon" (click)="removeEventLink(index)">delete</i>
      </div>
    </div>
    <div class="add-multiple">
      <span class="pointer" (click)="addLLink()">
        <i class="material-icons float-left add-icon">add_circle_outline</i>
        <span class="float-left add-text">Link</span>
      </span>
    </div>
  </div>

  <div>
    <label>Thumbnail
      <section class="upload-area create-post" ng2FileDrop [uploader]="uploader" (onFileDrop)="fileDropOver($event)" (fileOver)="fileOverBase($event)">
        <div class="row upload-choose-btn tpiq-upload-section" [ngClass]="{'popup-file-over': hasBaseDropZoneOver}">
          <div class="columns medium-12 text-center">
                <span class="pointer">
                  <img src="../../../images/tpiq-icons/upload-cloud.png"/>
                  <label for="eventThumbnailUpload" class="button upload-section-content">Upload logo for event thumbnail.</label>
                </span>
            <input type="file" accept=".pdf,image/*" id="eventThumbnailUpload" (change)="fileDropOver($event)" value="null" class="show-for-sr" ng2FileSelect [uploader]="uploader"/>
          </div>
        </div>
      </section>
    </label>
  </div>
  <div class="mt-3" *ngIf="logoFiles.length > 0">
    <div class="d-flex flex-wrap">
      <div class="d-flex uploaded-file-box mb-2 flex-column" *ngFor="let logo of logoFiles; let index = index;">
        <ng-template [ngIf]="logo.name">
          <div class="d-flex justify-content-between file-name-box">
            <div class="file-name">{{logo.name}}</div>
            <div class="pointer" (click)="deleteDocumentFile(logo, index)">
              <i class="icon ion-android-close"></i>
            </div>
          </div>
          <div class="mt-2" style="padding: 0px;margin-left: 0px" *ngIf="logo.link">
            <img class="image-zoom" [src]="logo.link"/>
          </div>
        </ng-template>
      </div>
    </div>
  </div>
</div>
<div class="mt-4 flex-shrink-0">
  <button class="button small float-right" (click)="updateOneOnOne()">Update</button>
</div>
